import { MonthNav } from "@/components/MonthNav";
import { DateRangeButtons } from "@/components/DateRangeButtons";

// One shared date framework used identically on Map, Table and Calendar:
// the month stepper (‹ Month › + Today) AND the range dropdown, side by side on a
// single line, both driven by the shared dateRange so every view always agrees.
export function DateControls({ dark = false, className = "", hideToday = false }) {
  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className}`} data-testid="date-controls">
      <MonthNav dark={dark} hideToday={hideToday} />
      <DateRangeButtons dark={dark} align="left" />
    </div>
  );
}
